export default __webpack_public_path__ + "static/media/r6.32a32845.jpg";